"use strict";
// Password policy (decision D-0003): long passwords instead of composition rules,
// plus a block-list of common and company-related passwords.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PASSWORD_MIN_LENGTH = exports.PASSWORD_MAX_LENGTH = void 0;
exports.passwordProblems = passwordProblems;
exports.PASSWORD_MAX_LENGTH = 128;
exports.DEFAULT_PASSWORD_MIN_LENGTH = 12;
const COMMON = [
    'password', 'password1', 'password123', 'passw0rd', 'p@ssw0rd', 'p@ssword', 'qwerty', 'qwerty123',
    'qwertyuiop', 'asdfghjkl', 'zxcvbnm', '123456', '1234567', '12345678', '123456789', '1234567890',
    '0123456789', '111111', '000000', 'abc123', 'abcd1234', 'iloveyou', 'welcome', 'welcome1',
    'welcome123', 'letmein', 'admin', 'admin123', 'administrator', 'changeme', 'default', 'monkey',
    'dragon', 'football', 'baseball', 'sunshine', 'princess', 'master', 'superman', 'trustno1',
    'blink', 'blinkops', 'blink123', 'blink2026', 'blinkdelivery', 'courier', 'delivery', 'dubai',
    'dubai123', 'uae', 'emirates', 'abudhabi', 'sharjah', 'transcorp', 'ajex', 'fleetbase',
];
function stripped(value) {
    return value.toLowerCase().replace(/[^a-z0-9@]/g, '');
}
/** Returns a list of problems; empty means the password is acceptable. */
function passwordProblems(password, opts = {}) {
    const min = opts.minLength ?? exports.DEFAULT_PASSWORD_MIN_LENGTH;
    const problems = [];
    if (password.length < min)
        problems.push('TOO_SHORT');
    if (password.length > exports.PASSWORD_MAX_LENGTH)
        problems.push('TOO_LONG');
    const s = stripped(password);
    const withoutDigits = s.replace(/\d+$/, '');
    if (COMMON.includes(s) || COMMON.includes(withoutDigits) || /^(.)\1+$/.test(password)) {
        problems.push('TOO_COMMON');
    }
    const localPart = opts.email?.split('@')[0]?.toLowerCase();
    const nameParts = (opts.fullName ?? '').toLowerCase().split(/\s+/).filter((p) => p.length >= 4);
    const lower = password.toLowerCase();
    if ((localPart && localPart.length >= 4 && lower.includes(localPart)) || nameParts.some((p) => lower.includes(p))) {
        problems.push('CONTAINS_NAME');
    }
    return problems;
}
//# sourceMappingURL=password.js.map